import { EntityModel } from '@/interfaces'
import {
  ALL_RATIO_CONFIGS_QUERY,
  CREATE_RATIO_CONFIG_MUTATION,
  DELETE_RATIO_CONFIG_MUTATION,
  FORCE_DELETE_RATIO_CONFIG_MUTATION,
  SINGLE_RATIO_CONFIG_QUERY,
  UPDATE_RATIO_CONFIG_MUTATION,
} from './graphql'

const tenantRatioConfigModel: EntityModel = {
  name: 'ratioConfig',
  namePlural: 'ratioConfigs',
  uniqueName: 'tenantRatioConfig',
  uniqueNamePlural: 'tenantRatioConfigs',
  path: 'config/tenant/ratio_config',
  baseUrl: '/config/tenant/ratio_configs',
  translationPrefix: 'entities:tenantRatioConfig.',
  getDisplayName: (values: any) => {
    return 'TENANT RATIO CONFIG'
  },
  gql: {
    getAll: ALL_RATIO_CONFIGS_QUERY,
    getSingle: SINGLE_RATIO_CONFIG_QUERY,
    create: CREATE_RATIO_CONFIG_MUTATION,
    update: UPDATE_RATIO_CONFIG_MUTATION,
    delete: DELETE_RATIO_CONFIG_MUTATION,
    forceDelete: FORCE_DELETE_RATIO_CONFIG_MUTATION,
  },
  attributes: {
    adressgruppe: {
      name: 'adressgruppe',
      label: 'entities:tenantRatioConfig.attributes.adressgruppe.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'number',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
  },
}

export default tenantRatioConfigModel
